import React from "react";
import RestLogo from "../../../../../helper/images/restologo.png";
import { Link } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { useTranslation } from "../../../../../hooks/useTranslation";
const AboutRestaurant = ({ restaurant }) => {
  const { t } = useTranslation();
  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hourStr, minute] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  const isRestaurantOpen = (opening, closing) => {
    if (!opening || !closing) return false;

    const now = new Date();

    const [openHour, openMinute] = opening.split(":").map(Number);
    const [closeHour, closeMinute] = closing.split(":").map(Number);

    const openingTime = new Date();
    openingTime.setHours(openHour, openMinute, 0, 0);

    const closingTime = new Date();
    closingTime.setHours(closeHour, closeMinute, 0, 0);

    return now >= openingTime && now <= closingTime;
  };

  const featureOptions = [
    { value: "wifi", label: t("aboutRestaurant").features.wifi },
    { value: "parking", label: t("aboutRestaurant").features.parking },
    {
      value: "outdoor_seating",
      label: t("aboutRestaurant").features.outdoor_seating,
    },
    { value: "live_music", label: t("aboutRestaurant").features.live_music },
    {
      value: "pet_friendly",
      label: t("aboutRestaurant").features.pet_friendly,
    },
    {
      value: "kid_friendly",
      label: t("aboutRestaurant").features.kid_friendly,
    },
    {
      value: "vegan_options",
      label: t("aboutRestaurant").features.vegan_options,
    },
    {
      value: "wheelchair_accessible",
      label: t("aboutRestaurant").features.wheelchair_accessible,
    },
    {
      value: "reservations",
      label: t("aboutRestaurant").features.reservations,
    },
    { value: "takeaway", label: t("aboutRestaurant").features.takeaway },
    { value: "delivery", label: t("aboutRestaurant").features.delivery },
    { value: "buffet", label: t("aboutRestaurant").features.buffet },
    { value: "bar", label: t("aboutRestaurant").features.bar },
    {
      value: "private_dining",
      label: t("aboutRestaurant").features.private_dining,
    },
    {
      value: "smoking_area",
      label: t("aboutRestaurant").features.smoking_area,
    },
    // { value: "parking", label: "Parking Available" },
    // { value: "outdoor_seating", label: "Outdoor Seating" },
    // { value: "live_music", label: "Live Music" },
    // { value: "pet_friendly", label: "Pet Friendly" },
    // { value: "kid_friendly", label: "Kid Friendly" },
    // { value: "vegan_options", label: "Vegan Options" },
    // { value: "wheelchair_accessible", label: "Wheelchair Accessible" },
    // { value: "reservations", label: "Accepts Reservations" },
    // { value: "takeaway", label: "Takeaway Available" },
    // { value: "delivery", label: "Home Delivery" },
    // { value: "buffet", label: "Buffet Service" },
    // { value: "bar", label: "Bar Available" },
    // { value: "private_dining", label: "Private Dining" },
    // { value: "smoking_area", label: "Smoking Area" },
  ];

  return (
    <>
      <div className="">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[19px] mb-[25px]">
          <div className="flex gap-5 items-center">
            <img
              src={
                restaurant?.logo?.length > 0 ? `${restaurant?.logo}` : RestLogo
              }
              alt=""
              className="w-[100px] h-[100px] rounded-full"
            />
            <div>
              <h2 className="text-[22px] font-semibold leading-[30px] mb-[10px] text-[#18181B]">
                {restaurant?.name}
              </h2>
              <p className="text-lg text-[#18181B]">
                {restaurant?.description}
              </p>
            </div>
          </div>
          <div>
            <div className="text-[#18181B] text-[18px] font-medium py-[11px] px-[22px] border border-[#DDDDDD] rounded-full text-center w-max md:ml-auto">
              {isRestaurantOpen(
                restaurant?.openingTime,
                restaurant?.closingTime
              )
                ? t("aboutRestaurant").openNow
                : t("aboutRestaurant").closedNow}
              : {formatTime(restaurant?.openingTime)} –{" "}
              {formatTime(restaurant?.closingTime)} (Today)
            </div>
            <a
              href={`tel:${restaurant?.contact}`}
              className="flex items-center justify-center w-full max-w-[228px] rounded-[2px] bg-[#FFA808] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 yellow-shadow hover:bg-[#D69723] gap-[5px] md:ml-auto mt-[15px]"
            >
              <IoCall size={24} />
              {restaurant?.contact}
            </a>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-[auto_auto] gap-[19px] mt-[25px] px-[22px] pt-[30px] pb-[39px] bg-[#FFFAF2] rounded-[10px]">
          <div className="md:max-w-[1000px]">
            <div className="mb-[15px]">
              <h2 className="text-[22px] text-[#18181B] font-semibold ">
                {t("aboutRestaurant").cuisineType}
              </h2>
              <p className="text-lg text-[#18181B] mt-[10px]">
                {restaurant?.cuisineType
                  ? restaurant?.cuisineType.join(",")
                  : ""}
              </p>
            </div>
            <div className="mb-[15px]">
              <h2 className="text-[22px] text-[#18181B] font-semibold ">
                {t("aboutRestaurant").contactInformation}
              </h2>
              <ul className="text-lg text-[#18181B] mt-[10px]">
                <li>
                  <span className="font-medium">
                    {t("aboutRestaurant").phoneNumber}
                  </span>
                  {restaurant?.contact}
                </li>
                <li>
                  <span className="font-medium">
                    {t("aboutRestaurant").email}
                  </span>
                  {restaurant?.email}
                </li>
                <li>
                  <span className="font-medium">
                    {t("aboutRestaurant").website}
                  </span>
                  {restaurant?.website}
                </li>
              </ul>
            </div>
            <div className="flex items-center flex-wrap">
              <h2 className="text-[22px] text-[#18181B] font-semibold ">
                {t("aboutRestaurant").streetAddress}
              </h2>
              <p className="text-lg text-[#18181B] mt-[10px]">
                {restaurant?.address}
              </p>
            </div>
          </div>
          <div className="mb-[15px]">
            <h2 className="text-[22px] text-[#18181B] font-semibold ">
              {t("aboutRestaurant").specialFeatures}
            </h2>
            {restaurant?.features ? (
              <ol className="text-lg text-[#18181B] mt-[10px] list-disc list-inside">
                {restaurant.features.split(",").map((featureValue, index) => {
                  const matchedFeature = featureOptions.find(
                    (opt) => opt.value === featureValue.trim()
                  );
                  return (
                    <li key={index}>
                      {matchedFeature
                        ? matchedFeature.label
                        : featureValue.trim()}
                    </li>
                  );
                })}
              </ol>
            ) : (
              <p className="text-[#999] text-base mt-[10px]">
                {t("aboutRestaurant").noFeatures}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutRestaurant;
